import {
  type TutorialObjective,
  TutorialMessageColors
} from '@powerplay/core-minigames'
import { defineStore } from 'pinia'

export interface TutorialState {
  anne: {
    showAnne: boolean,
    isRight: boolean
  },
  mobile: boolean,
  tutorialMessage: {
    message: string,
    showMessage: boolean,
    color: TutorialMessageColors,
    yellowText: string,
    yellowTextSpecial: boolean,
    offset: boolean
  },
  objectives: TutorialObjective[],
  settings: boolean,
  buttons: {
    showTempo: boolean,
    showJoystick: boolean
  },
  showBarSpeed: boolean,
  instructionBoxText: string,
  instructionBoxIcon: number,
  showInstructionBox: boolean,
  slipStreamSeconds: number
}

const initialState = (): TutorialState => ({
  anne: {
    showAnne: false,
    isRight: false
  },
  mobile: false,
  tutorialMessage: {
    message: '',
    showMessage: false,
    color: TutorialMessageColors.blank,
    yellowText: '',
    yellowTextSpecial: false,
    offset: false
  },
  settings: false,
  objectives: [],
  buttons: {
    showTempo: false,
    showJoystick: false
  },
  showBarSpeed: false,
  instructionBoxText: '',
  instructionBoxIcon: -1,
  showInstructionBox: false,
  slipStreamSeconds: 0
})

export const tutorialState = defineStore('tutorialState', {
  state: initialState
})
